window.addEventListener( 'load', () => {
  // Script that checks if the price is zero
  const productPriceZero = document.querySelector(".product-pricing-zero")
  const productBtnAddToCart = document.querySelector("product-to-cart button:not(.rfq-btn)")
  if (productPriceZero && productBtnAddToCart) productBtnAddToCart.remove()
})


// Script that checks if the price is zero in the modal
const observer = new MutationObserver(function(mutationsList, observer) {
  for ( let mutation of mutationsList ) {
    if ( mutation.type === 'childList' ) {
      const modal = document.querySelector( '#snize-modal-product-quick-view' )
      if( modal ) {
        const priceInModal = modal.querySelector( '.snize-quick-view-price-wrapper .snize-price' )
        const productForm = modal.querySelector( '.snize-quick-view-form-wrapper' )

        if( priceInModal ) {
          let priceText = priceInModal.textContent.replace(/[^\d.]/g, '')
          if (priceText === "0" || priceText === "0.00") {
            priceInModal.textContent = "Contact us for Pricing"
            if (productForm) productForm.remove()
          }
        }
      }

      const productPrices = document.querySelectorAll( '.snize-product .snize-price-list .snize-price' )
      if( productPrices.length > 0 ) {
        productPrices.forEach( price => {
          let priceText = price.textContent.replace(/[^\d.]/g, '')
          if( priceText === "0" || priceText === "0.00" ) {
            price.textContent = "Contact us for Pricing"
          }
        })
      }
    }
  }
})
observer.observe(document.body, { childList: true, subtree: true })




/* Script that checks if the price is zero in the modal
const observer = new MutationObserver(function(mutationsList, observer) {
  for( let mutation of mutationsList ) {
    if( mutation.type === 'childList' ) {
      const modal = document.querySelector('#snize-modal-product-quick-view')
      if( modal ) {
        const price = modal.querySelector('.snize-quick-view-price-wrapper .snize-price')
        const productForm = modal.querySelector('.snize-quick-view-form-wrapper')

        if( price ) {
          let priceText = price.textContent.replace(/[^\d.]/g, '')
          if(priceText === "0" || priceText === "0.00") {
            price.textContent = "Contact us for Pricing"
            if (productForm) productForm.remove()
          }
        }
      }
    }
  }
})
observer.observe(document.body, { childList: true, subtree: true }) */



/* Detener la observación cuando el modal se cierra (opcional)
document.addEventListener('click', function(event) {
    if (event.target.classList.contains('snize-quick-view-button')) {
        setTimeout(() => {
            const modal = document.querySelector('#snize-modal-product-quick-view')
            if (!modal) {
                observer.disconnect() // Desconectar el observer si el modal ya no está
            }
        }, 500)
    }
}) */


